import React, { type FC, type PropsWithChildren } from 'react'
import { Box, Divider, Stack, type SxProps, type Theme } from '@mui/material'

import { Breadcrumbs } from './Breadcrumbs'
import { SideNavigation } from './SideNavigation'

const columnStyle: SxProps<Theme> = { height: '100%', overflowY: 'auto' }
const staticColumnStyle: SxProps<Theme> = { flexShrink: 0, overflowX: 'hidden' }
const mainContentStyle: SxProps<Theme> = { p: 6, flexGrow: 1, width: 0 }
export const RouteNavigation: FC<PropsWithChildren> = ({ children }) => (
    <Stack flexGrow={1} direction="row">
        <Box sx={[columnStyle, staticColumnStyle]}>
            <SideNavigation />
        </Box>
        <Box sx={[columnStyle, staticColumnStyle]}>
            <Divider orientation="vertical" />
        </Box>
        <Box sx={[columnStyle, mainContentStyle]}>
            <Breadcrumbs />
            {children}
        </Box>
    </Stack>
)
